import { render, staticRenderFns } from "./SearchResultBox.vue?vue&type=template&id=8b59972e&"
import script from "./SearchResultBox.vue?vue&type=script&lang=js&"
export * from "./SearchResultBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports